import { ref } from 'vue'

export default () => {
  return {
    accessToken: ref(null),
    accessTokenExpiresAt: ref(null),
    refreshToken: ref(null),

    refreshTimer: ref(null)
  }
}
